module.exports = __webpack_public_path__ + "static/media/BreathingTechniques.f1138604.mp3";